import { Activity } from './options/activity';
import { Service } from './options/service';
import { GymType } from './gym';

export class Options {
  gymTypes: GymType[];
  activities: Activity[];
  services: Service[];
  gymEquipments: string[];
  equipmentsToBring: string[];
  gymInfos: string[];
  networks: string[];
  geniusFeatures: string[];
}
